export const ANIMATION_DURATION = 250;
